export const onlyInputnumber = (num) => {
    num = num.replace(/[^\d.]/g, '');
    // 保证只有出现一个.而没有多个.
    num = num.replace(/\.{2,}/g, '.');
    // 必须保证第一个为数字而不是.
    num = num.replace(/^\./g, '');
    // 保证.只出现一次，而不能出现两次以上
    num = num
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
    // 只能输入两个小数
    num = num.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于01、02的金额
    // eslint-disable-next-line no-irregular-whitespace
    if (num.indexOf('.') < 0 && num !== '') {
        // eslint-disable-next-line no-irregular-whitespace
        num = parseFloat(num);
    }
    return num;
};
// 两个浮点数相减
export const accSub = (arg1, arg2) => {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2)); // last modify by deeka //动态控制精度长度
    n = (r1 >= r2) ? r1 : r2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

// 千位符
export const moneyFormat = (num) => {
    return (Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
};

export const del = (obj, keys) => {
    keys.map(key => {
        delete obj[key];
    });
    return obj;
};

export const stAi = (obj, data) => {
    Object.keys(obj).forEach(key => {
        Object.keys(data).forEach(subKey => {
            if (key === subKey) {
                data[key] = obj[subKey];
            }
        });
    });
    return data;
};

export const messageBox = (vue) => {
    return vue.$confirm('您确定要取消这次编辑吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    });
};